// extracted by mini-css-extract-plugin
module.exports = {"block":"ApproveModal_block__15D4Y","isOpen":"ApproveModal_isOpen__DfZHh","isFullWidth":"ApproveModal_isFullWidth__3wIZA","shortly":"ApproveModal_shortly__3bHlS"};